import USE_MERCURE from '~/const/mercure';
import { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX } from '~/const/infix';

const buildHomeUrl = locale => "/".concat(locale.market, "/").concat(locale.language);

const CgvType = {
  PRO: 'cgv-pro',
  MARKETPLACE: 'cgv-marketplace',
  DEFAULT: 'cgv'
};

const buildCategoryUrl = (locale, slug, hash) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(CATEGORY_INFIX, "/").concat(slug, "-").concat(hash);

const buildProductUrl = (locale, slug, reference, offer) => {
  let url = "/".concat(locale.market, "/").concat(locale.language, "/").concat(PRODUCT_INFIX, "/").concat(slug, "-").concat(reference, ".htm");

  if (offer) {
    url = "".concat(url, "?offer=").concat(offer);
  }

  return url;
};

const buildCustomProductUrl = (locale, reference) => "/".concat(locale.market, "/").concat(locale.language, "/configurator/product/").concat(reference);

const buildStaticUrl = (locale, slug, oldVersion) => {
  if (oldVersion) {
    // handle WEB static pages url until they switch to nuxt
    return "/".concat(locale.market, "/").concat(locale.language, "/").concat(slug);
  }

  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(STATIC_INFIX, "/").concat(slug);
};

const buildSearchUrl = (locale, query) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(SEARCH_INFIX, "/").concat(query);

const buildEditoUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/").concat(page);

const buildMyAccountUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/user");

const buildFaqUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/faq/").concat(page);

const buildContactFormUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/contact/").concat(page);

const buildReturnFormUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/return/").concat(page);

const buildCgvUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legal/").concat(CgvType[page] || CgvType.DEFAULT);

const buildShippingUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/shipping");

const buildPaymentUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/payment");

const buildPaymentPaypalPendingUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-pending");

const buildPaymentPaypalCanceledUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-canceled");

const buildPaymentConfirmedUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/confirmed");

const buildPaymentRefusedUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/refused");

const buildMerchantUrl = (locale, slug, reference) => "/".concat(locale.market, "/").concat(locale.language, "/m/").concat(slug, "-").concat(reference);

const buildCartUrl = locale => USE_MERCURE(locale.iso) ? "/".concat(locale.market, "/").concat(locale.language, "/cart") : "/".concat(locale.market, "/").concat(locale.language, "/panier.html");

const buildLoginUrl = (locale, isTunnel) => isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/login") : "/".concat(locale.market, "/").concat(locale.language, "/login");

const buildSignupUrl = (locale, isTunnel) => isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/signup") : "/".concat(locale.market, "/").concat(locale.language, "/signup");

export const urlBuilder = {
  buildCartUrl,
  buildCgvUrl,
  buildShippingUrl,
  buildHomeUrl,
  buildLoginUrl,
  buildMerchantUrl,
  buildMyAccountUrl,
  buildPaymentUrl,
  buildPaymentPaypalPendingUrl,
  buildPaymentPaypalCanceledUrl,
  buildPaymentConfirmedUrl,
  buildPaymentRefusedUrl,
  buildProductUrl,
  buildCustomProductUrl,
  buildSignupUrl
};
export default {
  methods: {
    buildCartUrl,
    buildCategoryUrl,
    buildContactFormUrl,
    buildEditoUrl,
    buildFaqUrl,
    buildLoginUrl,
    buildProductUrl,
    buildReturnFormUrl,
    buildSearchUrl,
    buildStaticUrl
  }
};